// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'http://localhost:5002/api/v1'
};

export const firebaseConfig = {
  apiKey: "AIzaSyAmoZy0NIum91DAaujfADHsqVsuSIdfmnQ",
  authDomain: "pagg-i.firebaseapp.com",
  databaseURL: "https://pagg-i.firebaseio.com",
  projectId: "pagg-i",
  storageBucket: "pagg-i.appspot.com",
  messagingSenderId: "369705893702",
  appId: "1:369705893702:web:c0795c52232e711b28af47"
};

export const algoliaConfig = {
  appId: 'R0EGXSNY6K',
  apiKey: '521484e42ee88d0db1cf244a88347998'
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
